import { createSelector } from '@reduxjs/toolkit';
import { selectObjectTypeOptions } from './selectObjectTypeOptions';
import { selectObjectTypeValue } from './selectObjectTypeValue';

export const selectObjectTypeFilter = createSelector(
  [selectObjectTypeValue, selectObjectTypeOptions],
  (value, options) => ({
    value,
    options,
  }),
);
